/**
 * @module api-web:cc
 * @description
 */
import service from '@/service'

// 列表查询接口
export function getList(data) {
  return service['api-web']({
    url: '/eco/skuID/getList',
    method: 'post',
    data
  })
}

/**
 * @description 列表导出（提交导出任务，异步生成，前往下载任务中心下载）
 * @param {Object} data 与列表查询同口径，无分页参数
 * @param {string} [data.skuId] skuID
 * @param {string} [data.skuCode] SKU
 * @param {(string|number)} [data.salesman] 销售员
 * @param {(string|number)} [data.matchPerson] 匹配人
 * @param {string} [data.beginMatchDate] 匹配日期（开始）
 * @param {string} [data.endMatchDate] 匹配日期（结束）
 */
export function exportData(data) {
  return service['api-web']({
    url: '/eco/skuID/export',
    method: 'post',
    data
  })
}

/**
 *  下载模板
 */
export function downloadExcel() {
  return service['api-web']({
    url: '/eco/skuID/downloadExcel',
    method: 'post',
    responseType: 'blob', // 文件流接收类型声明转成 blob
    saveAs: false, // 文件流是否通过浏览器下载， 下载的模板文件名需要有 buttonGroup 配置，所有不通过 axios 下载
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @description 模板匹配
 */
export function templateMatch(data) {
  return service['api-web']({
    url: '/eco/skuID/templateMatch',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * @description 模板匹配确认
 */
export function checkMactchDataExistForExcel(data) {
  return service['api-web']({
    url: '/public/data/checkMactchDataExistForExcel',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * @description 获取任务详情列表
 */
export function getTaskInfoList(params) {
  return service['api-web']({
    url: '/eco/jd/getTaskInfoList',
    method: 'get',
    params
  })
}

/**
 * @description 单个同步
 */
export function singleMatch(data) {
  return service['api-web']({
    url: '/eco/skuID/singleMatch',
    method: 'post',
    data
  })
}

/**
 *判断判断匹配数据是否已存在
 */
export function checkMactchDataExist(data) {
  return service['api-web']({
    url: '/public/data/checkMactchDataExist',
    method: 'post',
    data
  })
}

/**
 * @description 获取sku列表
 */
export function getAuditAndEnabledProductSku(params) {
  return service['api-web']({
    url: '/public/product/getAuditAndEnabledProductSku',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/** *
 * @description 客户匹配查询列表
 */
export function getClientMatchList(data) {
  return service['api-web']({
    url: '/eco/skuID/clientMatch/getList',
    method: 'post',
    data
  })
}

/** *
 * @description 客户匹配查询列表
 */
export function confirm(data) {
  return service['api-web']({
    url: '/eco/skuID/clientMatch/confirm',
    method: 'post',
    data
  })
}
